const state = {
    pageDisableInitialLoading: false,
    snackbarVisible: false,
    snackbarText: "",
    snackbarColor: "",
    snackbarOutlined: false,

    //Confirmation dialog
    showConfirmationDialog: false,
    confirmationDialogMessage: '',

    //message dialog
    showMessageDialog: false,
    messageDialogMessage: '',

    // mobileSideMenuVisible: false,
    // isMobileSize: false,
};

const getters = {
    isPageDisableInitialLoading(){
        return state.pageDisableInitialLoading;
    },
    getSnackbarVisible(state){
        return state.snackbarVisible;
    },
    getSnackbarText(state){
        return state.snackbarText;
    },
    getSnackbarColor(state){
        return state.snackbarColor;
    },
    getSnackbarOutlined(state){
        return state.snackbarOutlined;
    },

    getShowConfirmationDialog(state){
        return state.showConfirmationDialog;
    },
    getConfirmationDialogMessage(state){
        return state.confirmationDialogMessage;
    },

    getShowMessageDialog(state){
        return state.showMessageDialog;
    },
    getMessageDialogMessage(state){
        return state.messageDialogMessage;
    },


    // getMobileSideMenuVisible(state){
    //     return state.mobileSideMenuVisible;
    // },
    // isMobile(state){
    //     return state.isMobileSize;
    // }
};

const mutations = {
    setPageDisableInitialLoading(state, payload){
        state.pageDisableInitialLoading = payload;
    },
    setSnackbarVisible(state, payload){
        state.snackbarVisible = payload;
    },
    setSnackbarText(state, payload){
        state.snackbarText = payload;
    },
    setSnackbarColor(state, payload){
        state.snackbarColor = payload;
    },
    setSnackbarOutlined(state, payload){
        state.snackbarOutlined = payload;
    },

    setShowConfirmationDialog(state, payload){
        state.showConfirmationDialog = payload;
    },
    setConfirmationDialogMessage(state, payload){
        state.confirmationDialogMessage = payload;
    },

    setShowMessageDialog(state, payload){
        state.showMessageDialog = payload;
    },
    setMessageDialogMessage(state, payload){
        state.messageDialogMessage = payload;
    },


    // setMobileSideMenuVisible(state, payload){
    //     state.mobileSideMenuVisible = payload;
    // },
    // setMobileSize(state, payload){
    //     state.isMobileSize = payload;
    // }
};

const actions = {
    setPageDisableInitialLoading({commit}, payload){
        commit('setPageDisableInitialLoading', payload);
    },
    setSnackbarVisible({commit}, payload){
        commit('setSnackbarVisible', payload);
    },
    setSnackbarText({commit}, payload){
        commit('setSnackbarText', payload);
    },
    setSnackbarColor({commit}, payload){
        commit('setSnackbarColor', payload);
    },
    setSnackbarOutlined({commit}, payload){
        commit('setSnackbarOutlined', payload);
    },

    setShowConfirmationDialog({commit}, payload){
        commit('setShowConfirmationDialog', payload);
    },
    setConfirmationDialogMessage({commit}, payload){
        commit('setConfirmationDialogMessage', payload);
    },

    setShowMessageDialog({commit}, payload){
        commit('setShowMessageDialog', payload);
    },
    setMessageDialogMessage({commit}, payload){
        commit('setMessageDialogMessage', payload);
    },

    // setMobileSideMenuVisible({commit}, payload){
    //     commit('setMobileSideMenuVisible', payload);
    // },
    // setMobileSize({commit}, payload){
    //     commit('setMobileSize', payload);
    // }
};

export default {
    state,
    getters,
    mutations,
    actions
};
